import React, { useState } from 'react';
import "@/App.css";
import { AuthProvider, useAuth } from './context/AuthContext';
import LoginPage from './pages/LoginPage';
import CompaniesPage from './pages/CompaniesPage';
import DashboardPage from './pages/DashboardPage';
import AdminPage from './pages/AdminPage';

const AppContent = () => {
  const { isAuthenticated, isAdmin, loading } = useAuth();
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [showAdmin, setShowAdmin] = useState(false);

  if (loading) {
    return (
      <div className="min-h-screen bg-slate-50 flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-slate-900"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <LoginPage />;
  }

  // Show admin panel if admin user chooses to
  if (isAdmin && showAdmin) {
    return <AdminPage onBack={() => setShowAdmin(false)} />;
  }

  if (selectedCompany) {
    return (
      <DashboardPage 
        company={selectedCompany} 
        onBack={() => setSelectedCompany(null)} 
      />
    );
  }

  return (
    <CompaniesPage 
      onSelectCompany={setSelectedCompany} 
      isAdmin={isAdmin}
      onShowAdmin={() => setShowAdmin(true)}
    />
  );
};

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;
